import { DealDetailsActionTypes } from "Redux/actionTypes";
import {
  extractProductList, isDoubleDealDevice, extractDeviceColorOptions,
  extractInclusionColorOptions, selectInitialColor, isValidRouterResponse,
  isValidDeviceColor
} from "utils/dealDetails";

import ajaxService from "utils/ajaxServices";

import {
  DealDetail as DealDetailsQuery,
  getAll5GRouters as GetAll5GRoutersQuery,
  RelatedDeals as RelatedDealsQuery
} from "../../config/queries";

export const getAndSetDealDetails = (url_key) => async (dispatch) => {

  if (!url_key) {
    return {
      ok: false,
      isError: true,
    };
  }

  const queryVariables = {
    url_key: url_key,
  };

  const result = await ajaxService.fetchGraphQLPOSTRequest(
    DealDetailsQuery,
    queryVariables,
    "",
    true,
    false, 
    {
      headers: {
        'Cache-Control': 'max-age=300'
      }
    }
  );

  if (
    !result
    || !result.products
    || !Array.isArray(result.products.items)
    || !result.products.items.length
  ) {
    return {
      ok: false,
      isError: true,
      status: result.status,
    };
  }

  const contractsDurations = result?.products?.items.map((contract) => ({
    id: contract.sku,
    duration: contract.payment_terms_label,
    price: contract.monthly_recurring,
    old_installment: contract.old_installment,
    old_monthly_recurring: contract.old_monthly_recurring,
    old_tariff: contract.old_tariff
  }));
  
  const activeDealValue = result?.products?.items?.find(
    (item) => item.url_key === url_key
  );

  const allProductsUnderContract = extractProductList(activeDealValue);

  const isDoubleDeal = isDoubleDealDevice(allProductsUnderContract);
  
  const primaryProduct = allProductsUnderContract.find((item) => item.isPrimary) || null;
  const secondaryProduct = isDoubleDeal
    ? allProductsUnderContract.find((item) => item.isSecondary || item.optionQuantity > 1)
    : null;

  const anyTimeDataSku = activeDealValue?.anytime_product_sku;
  const planDetails = allProductsUnderContract.find(
    (item) => item.sku === anyTimeDataSku
  ) || null;
  
  let extraProductsUnderContract = allProductsUnderContract.filter(
    (item) => !item.isPrimary && item.sku !== secondaryProduct?.sku && item.sku !== anyTimeDataSku
  );

  let allExtraItems = [];
  extraProductsUnderContract.forEach(extraItem => {
    for (let i = 0; i < extraItem.optionQuantity; i++) {
      allExtraItems.push(extraItem)
    }
  }
  );

extraProductsUnderContract = allExtraItems


  const primaryProductColors = extractDeviceColorOptions(primaryProduct);
  const secondaryProductColors = extractDeviceColorOptions(secondaryProduct);
  const dealInclusionColors = extractInclusionColorOptions(extraProductsUnderContract);
  const selectedPrimaryDeviceColor = selectInitialColor(primaryProductColors);
  const selectedSecondaryDeviceColor = selectInitialColor(secondaryProductColors);

  dispatch({
    type: DealDetailsActionTypes.SET_ALL_DEAL_DATA,
    payload: {
      attributeCodes: Array.isArray(result.products?.attribute_set_config)
        ? result.products?.attribute_set_config
        : [],
      dealList: result?.products?.items || [],
      contractsDurations: contractsDurations,
      contractsList: Array.isArray(result.contract_type_desc) ? result.contract_type_desc : [],
      dataPlanDetails: planDetails,
      dealInclusions: extraProductsUnderContract,
      dealInclusionColors: dealInclusionColors,
      primaryProductColors: primaryProductColors,
      primaryProduct: primaryProduct,
      relatedDeals: activeDealValue?.related_products,
      secondaryProduct: secondaryProduct,
      secondaryProductColors: secondaryProductColors,
      selectedDealDetails: activeDealValue,
      selectedPrimaryDeviceColor: selectedPrimaryDeviceColor,
      selectedSecondaryDeviceColor: selectedSecondaryDeviceColor,
      similarDeals: activeDealValue?.upsell_products || [],
    }
  });

  const showError = !activeDealValue;

  return {
    ok: true,
    isError: showError,
    status: result.status,
    productItem: result?.products?.items[0]
  };
}

export const setSelectedApplicationType = (buyOption) => (dispatch) => {
  if (typeof buyOption !== "object" || !buyOption?.option_type_id || !buyOption.title) return;

  dispatch({
    type: DealDetailsActionTypes.SET_APPLICATION_TYPE,
    payload: buyOption,
  });
}

export const getAndSetWhitelistedRouters = () => async (dispatch) => {
  const fiveGRouters = await ajaxService.fetchGraphQLPOSTRequest(
    GetAll5GRoutersQuery
  );

  if (!isValidRouterResponse(fiveGRouters)) return;

  dispatch({
    type: DealDetailsActionTypes.SET_WHITELISTED_ROUTERS,
    payload: fiveGRouters?.products?.items,
  });
}

export const getAndSetRelatedDeals = (manufacturerId) => async (dispatch) => {
  if (!manufacturerId)
    return {
      ok: false,
      error: new Error("Invalid params given"),
    };

  const result = await ajaxService.fetchGraphQLGetRequest(
    RelatedDealsQuery,
    {
      manufacturer: manufacturerId,
    }
  );

  if (!result || !Array.isArray(result?.products?.items)) {
    return {
      error: result.error,
      ok: false,
      status: result.status || result?.error?.status,
    }
  }

  dispatch({
    type: DealDetailsActionTypes.SET_RELATED_DEALS,
    payload: result.products?.items
  });

  return {
    ok: true,
    status: result.status,
  }
}

export const updateSelectedDealDetail = (dealSku) => (dispatch) => {
  if (!dealSku) return;

  dispatch({
    type: DealDetailsActionTypes.SET_DEAL_DETAILS,
    payload: { dealSku },
  });
}

export const updateSelectedDeviceColor = ({ primaryDeviceColor, secondaryDeviceColor}) => (dispatch) => {
  if (!isValidDeviceColor(primaryDeviceColor)
    && !isValidDeviceColor(secondaryDeviceColor)
  )
    return;

  dispatch({
    type: DealDetailsActionTypes.SET_DEVICE_COLOR,
    payload: {
      primaryDeviceColor: primaryDeviceColor,
      secondaryDeviceColor: secondaryDeviceColor
    },
  })
}

export const updateSelectedInclusionColor = (inclusionSku, inclusionColor) => (dispatch) => {
  if (!inclusionSku || !isValidDeviceColor(inclusionColor)) return;

  dispatch({
    type: DealDetailsActionTypes.SET_INCLUSION_COLOR,
    payload: {
      inclusionSku,
      inclusionColor,
    }
  });
}